import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import PendingSupplierOrders from "./PendingSupplierOrders";
import LiveursLocations from "./LiveursLocations";
import LivreursAlerts from "./LivreursAlerts";

// Définition du composant fonctionnel
function Dashboard() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Récupération des données de l'utilisateur depuis le stockage local
    const userData = JSON.parse(localStorage.getItem("userData"));

    // Définir les données de l'utilisateur dans l'état
    if (userData) {
      setUser(userData);
    }
  }, []);
  // Rendu du composant
  return (
    <Container>
      <p className="h1 pb-4 pt-4">
        Bonjour {user ? `${user.prenom} ${user.nom}` : "Administrateur"}
      </p>

      {/* Section Commandes */}
      <div style={{ paddingTop: "20px" }}>
        <h2 className="h3 pb-3" style={{ borderBottom: "2px solid #dee2e6" }}>
          Commandes
        </h2>
        <div style={{ paddingTop: "20px" }}>
          <PendingSupplierOrders />
        </div>
      </div>

      {/* Section Livreurs */}
      <div style={{ paddingTop: "40px" }}>
        <h2 className="h3 pb-3" style={{ borderBottom: "2px solid #dee2e6" }}>
          Livreurs
        </h2>
        <div style={{ paddingTop: "20px" }}>
          <LivreursAlerts />
        </div>
        <div style={{ paddingTop: "20px" }}>
          <LiveursLocations />
        </div>
      </div>
    </Container>
  );
}
// Exportation du composant par défaut
export default Dashboard;
